import { QueryClient } from 'react-query';

/**
 * Configuração padrão do QueryClient
 *
 * staleTime: Tempo que os dados são considerados "frescos" (5 min)
 * cacheTime: Tempo que dados não utilizados ficam em cache (10 min)
 * retry: Número de tentativas em caso de erro
 * refetchOnWindowFocus: Refetch ao focar na janela
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      cacheTime: 1000 * 60 * 10, // 10 minutos
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
